import { capitaliseWords } from "common/helpers";
import { useSelector } from "react-redux";
import { selectors } from "store";
import jobSelectors from "store/selectors/job";

export interface JobWorkTypePropsHook {
  isLoading: boolean;
  workType?: string;
}

export default function useJobWorkTypeProps(): JobWorkTypePropsHook {
  const isLoading = useSelector(selectors.getIsLoading);
  const job = useSelector(jobSelectors.getEntity);

  const workType = job?.work_type || "None selected";

  return {
    isLoading,
    workType: capitaliseWords(workType.replace(/_/g, " ")),
  };
}
